import { createSelector, createFeatureSelector, State } from '@ngrx/store';
import { AppActions, AppActitonTypes } from './app.actions';

export interface State {
    app: AppState;
}

export interface AppState {
	loading: boolean;
	loading1: boolean;
	loading2: boolean;
	loading3: boolean;
	loading4: boolean;
	loading5: boolean;
	loading6: boolean;
	alertModal: boolean;
	alertInfo: string;
	infoModal: boolean;
	infoInfo: string;
	linkInfo: string;
	paramInfo: any;
	skinInfo: string;
	error: string;
}

export const initialState: AppState = {
	loading: false,
	loading1: false,
	loading2: false,
	loading3: false,
	loading4: false,
	loading5: false,
	loading6: false,
	alertModal: false,
	alertInfo: '',
	infoModal: false,
	infoInfo: '',
	linkInfo: '',
	paramInfo: null,
	skinInfo: 'is-primary',
	error: ''
}



const getAppState = createFeatureSelector<AppState>('app');

export const getLoading = createSelector(
	getAppState,
	state => state.loading
);

export const getLoading1 = createSelector(
	getAppState,
	state => state.loading1
);

export const getLoading2 = createSelector(
	getAppState,
	state => state.loading2
);

export const getLoading3 = createSelector(
	getAppState,
	state => state.loading3
);

export const getLoading4 = createSelector(
	getAppState,
	state => state.loading4
);

export const getLoading5 = createSelector(
	getAppState,
	state => state.loading5
);

export const getLoading6 = createSelector(
	getAppState,
	state => state.loading6
);

export const getAlertModal = createSelector(
	getAppState,
	state => state.alertModal
);

export const getAlertInfo = createSelector(
	getAppState,
	state => state.alertInfo
);

export const getInfoModal = createSelector(
	getAppState,
	state => state.infoModal
);

export const getInfoInfo = createSelector(
	getAppState,
	state => state.infoInfo
);

export const getLinkInfo = createSelector(
	getAppState,
	state => state.linkInfo
);

export const getParamInfo = createSelector(
	getAppState,
	state => state.paramInfo
);

export const getSkinInfo = createSelector(
	getAppState,
	state => state.skinInfo
);

export const getError = createSelector(
	getAppState,
	state => state.error
);


// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: AppActions): AppState {

	// console.log('--> APP Reducer --> Estado actual: ' + JSON.stringify(state));
	console.log('--> Action APP type: ');
	console.log(action.type);

	switch (action.type) {

		case AppActitonTypes.ChangeLoading:

			console.log('--> Entrando en acción ChangeLoading.');
			console.log(action.payload);

			return {
                ...state,
				loading: action.payload
			};

		case AppActitonTypes.ChangeLoading1:

			// console.log('--> Entrando en acción ChangeLoading1.');

			return {
                ...state,
				loading1: action.payload
			};

		case AppActitonTypes.ChangeLoading2:

			// console.log('--> Entrando en acción ChangeLoading2.');

			return {
                ...state,
				loading2: action.payload
			};

		case AppActitonTypes.ChangeLoading3:

			console.log('--> Entrando en acción ChangeLoading3.');
			console.log(action.payload);

			return {
                ...state,
				loading3: action.payload
			};

		case AppActitonTypes.ChangeLoading4:

			// console.log('--> Entrando en acción ChangeLoading4.');

			return {
                ...state,
				loading4: action.payload
			};

		case AppActitonTypes.ChangeLoading5:

			// console.log('--> Entrando en acción ChangeLoading5.');

			return {
                ...state,
				loading5: action.payload
			};

		case AppActitonTypes.ChangeLoading6:

			// console.log('--> Entrando en acción ChangeLoading6.');
			// console.log(action.payload);

			return {
                ...state,
				loading6: action.payload
			};

		case AppActitonTypes.ChangeAlertModal:

			console.log('--> Entrando en acción ChangeAlertModal.');

			return {
				...state,
				alertModal: action.payload.value,
				alertInfo: action.payload.info
			};

		case AppActitonTypes.ChangeInfoModal:

			console.log('--> Entrando en acción ChangeInfoModal.');

			return {
				...state,
				infoModal: action.payload.value,
				infoInfo: action.payload.info,
				linkInfo: action.payload.link,
				paramInfo: action.payload.param,
				skinInfo: action.payload.skin
			};

		default:
			return state;
	}
}